
<div class="isg-tri-checkbox-container" [ngStyle]="{'width': getWidth()}">

  <label class="isg-tri-checkbox-label" >

    <span>
      <span *ngIf="checked == true">{{textTrue}} </span>
      <span *ngIf="checked == false">{{textFalse}} </span>
      <span *ngIf="checked == null || checked == undefined">{{textNotSpecified}} </span>

      <ng-content></ng-content>
    </span>

    <input class="isg-tri-checkbox-input"
           type="checkbox"
           [ngModel]="checked"
           [disabled]="isDisabled"
           (ngModelChange)="onModelChange($event)" />

    <i class="check-icon fa-light fa-square-check" *ngIf="checked == true"></i>
    <i class="check-icon fa-light fa-square-xmark" *ngIf="checked == false"></i>
    <i class="check-icon fa-light fa-square" *ngIf="checked == null || checked == undefined"></i>

  </label>

</div>

